import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {EditOutlined} from "@ant-design/icons-vue"



export default /*@__PURE__*/_defineComponent({
  __name: 'RestEdit',
  props: {
  value: {
    type: String,
    required: true
  },
},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const emit = __emit



const clickEdit = () =>{
  emit("click")
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    title: "编辑",
    onClick: clickEdit
  }, [
    _createVNode(_unref(EditOutlined)),
    _createTextVNode(" " + _toDisplayString(__props.value), 1)
  ]))
}
}

})